
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "BtnFullscreen",
  props: {
    element: Object,
    mode: {
      type: String as PropType<"default" | "icon" | "item">,
      default: "icon",
    },
    btnProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      modeProps: {
        default: {
          label: "Fullscreen",
        },
        icon: {
          icon: this.$q.fullscreen.isActive ? "fullscreen_exit" : "fullscreen",
          tooltip: "Fullscreen",
        },
        item: {
          label: "Fullscreen",
        },
      },
    };
  },
  computed: {
    btnPropsComputed(): any {
      return {
        size: "sm",
        ...this.modeProps[this.mode],
        ...this.btnProps,
      };
    },
  },
  methods: {
    toggleFullscreen() {
      this.$q.fullscreen.toggle(this.element as any);
    },
  },
});
